import HelpTooltip from '@/app/common/components/HelpTooltip';
import { crawlerContent } from '@/app/Crawl/config/modalSettingsConfig';
import type { FormikHandlers } from 'formik';
import { Col, Form, Row, Tab } from 'react-bootstrap';
import { crawlTooltip } from '@/app/Crawl/tooltip/crawlTooltips';

interface NumericSetting {
  name: string;
  text: string;
  min: number;
  max: number;
  measurement: string;
}

interface ContentProps {
  values: Record<string, unknown>;
  handleBlur: FormikHandlers['handleBlur'];
  handleChange: FormikHandlers['handleChange'];
}

const Content = ({ values, handleBlur, handleChange }: ContentProps) => {
  const settings = crawlerContent as NumericSetting[];

  // تنظیمات محتوای خزش
  return (
    <Tab.Pane className="my-3" eventKey="crawlerContent">
      {settings.map((item, index) => (
        <Row key={index} className="mb-2">
          <Col md={4}>
            <Form.Label className="">
              <span className="d-inline-flex align-items-center">
                {item.text}
                <HelpTooltip
                  html={crawlTooltip.crawlSettings.crawlerContent[item.name]}
                />
              </span>
            </Form.Label>
          </Col>
          <Col md={4}>
            <Form.Control
              size="sm"
              // key={index}
              type="number"
              value={values[item.name] as number | string | undefined}
              name={item.name}
              id={item.name}
              onChange={handleChange}
              onBlur={handleBlur}
              max={item.max}
              min={item.min}
            />
          </Col>
          <Col md={4}>
            <Form.Label>
              <div className="fs--2">
                از {item.min} تا {item.max} {item.measurement}
              </div>
            </Form.Label>
          </Col>
        </Row>
      ))}
    </Tab.Pane>
  );
};

export default Content;
